import toast from "react-hot-toast";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormDataMain, IAddTestQuestion } from "../../TestQuestion.props";
import { SubmitHandler } from "react-hook-form";

interface FormData1 {
  [key: string]: string | number | any;
}

const useAddTestQuestion = () => {
  const [formData, setFormData] = useState<FormData1>({
    questions: [
      {
        questionText: "",
        description: "",
        level: "",
        subject: "",
        standard: "",
        courseName: "",
        languageName: "",
        options: [
          { optionText: "", isCorrect: false },
          { optionText: "", isCorrect: false },
          { optionText: "", isCorrect: false },
          { optionText: "", isCorrect: false },
        ],
      },
    ],
  });

  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [courses, setCourses] = useState<any[]>([]);
  const [languages, setLanguages] = useState<any[]>([]);
  const [subjectName, setSubjectName] = useState<any[]>([]);
  const [standard, setStandard] = useState<any[]>([]);

useEffect(() => {
    fetchCoursesAndLanguages();
  }, []);

  
  const fetchCoursesAndLanguages = async () => {
    try {
      setLoading(true);
      const [
        coursesResponse,
        languagesResponse,
        subjectResponse,
        standardResponse,
      ] = await Promise.all([
        ApiService({ method: "GET", endpoint: apiPaths.getCourse }),
        ApiService({ method: "GET", endpoint: apiPaths.getlanguage }),
        ApiService({ method: "GET", endpoint: apiPaths.getSubject }),
        ApiService({ method: "GET", endpoint: apiPaths.getStandard }),
      ]);

      console.log(coursesResponse)
      setCourses(coursesResponse);
      setLanguages(languagesResponse);
      setSubjectName(subjectResponse);
      setStandard(standardResponse);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };


  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> | any,
    index?: number,
    optionIndex?: number
  ) => {
    const { name, value, type, checked } = e.target;
    
  
    setFormData((prevState: any) => {
      const updatedQuestions = [...prevState.questions];
  
      if (typeof index === "number") {
        if (typeof optionIndex === "number") {
          if (type === "checkbox") {
            // Unselect other options if any, ensuring only the current option is selected
            updatedQuestions[index].options = updatedQuestions[index].options.map((option: any, idx: number) => ({
              ...option,
              [name]: idx === optionIndex ? checked : false, // Only update the selected option to true, others to false
            }));
          } else {
            // For other input types, update the value directly
            updatedQuestions[index].options[optionIndex] = {
              ...updatedQuestions[index].options[optionIndex],
              [name]: type === "checkbox" ? checked : value,
            };
          }
          
        } else {
          // Update a field in a specific question
          updatedQuestions[index][name] = value;
        }
      } else {
        // Update formData fields that are not part of questions
        return {
          ...prevState,
          [name]: value,
        };
      }
      

      console.log("UPDATED Q : ",updatedQuestions)
      return { ...prevState, questions: updatedQuestions };
    });
  };
  

  const handleSubmit = async () => {

    console.log("Form data before submitting : ", formData);
  
    try {
      await ApiService({
        method: "POST",
        endpoint: apiPaths.liveMcq,
        data: formData,
      });
      toast.success("Questions added successfully");
      setFormData({
        questions: [
          {
            questionText: "",
            description: "",
            level: "",
            subject: "",
            standard: "",
            courseName: "",
            languageName: "",
            options: [
              { optionText: "", isCorrect: false },
              { optionText: "", isCorrect: false },
              { optionText: "", isCorrect: false },
              { optionText: "", isCorrect: false },
            ],
          },
        ],
      });
      navigate('/livemcq')
    } catch (error) {
      console.error("Error adding questions:", error);
      toast.error("Error adding questions");
    }
  };
  

  const addQuestion = () => {
    setFormData((prevState) => ({
      questions: [
        ...prevState.questions,
        {
          questionText: "",
          description: "",
          level: "",
          subject: "",
          standard: "",
          courseName: "",
          languageName: "",
          options: [
            { optionText: "", isCorrect: false },
            { optionText: "", isCorrect: false },
            { optionText: "", isCorrect: false },
            { optionText: "", isCorrect: false },
          ],
        },
      ],
    }));
  };
  
  const deleteQuestion = (index: number) => {
    if (formData.questions && formData.questions.length > 1) {
      const updatedQuestions = formData.questions.filter((_: any, i: number) => i !== index);
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        questions: updatedQuestions,
      }));
      console.log("Form data after deleting question : ", updatedQuestions);
    }
  };

  const handleCancel=()=>{
    navigate("/add-live-mcq")
  }

  return {
    loading,
    courses,
    languages,
    subjectName,
    standard,
    formData,
    deleteQuestion,
    handleChange,
    handleSubmit,
    addQuestion,
    handleCancel,
  };
};

export default useAddTestQuestion;
